import PropTypes from 'prop-types';
import React from 'react';

export default class Divider extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    render() {
        return (
            <div
                className={'hr' + (this.props.type || 1)}
                style={{
                    marginTop: (this.props.marginBottom || 40) + 'px',
                    marginBottom: (this.props.marginBottom || 40) + 'px',
                }}
            ></div>
        );
    }
}

Divider.propTypes = {
    type: PropTypes.number,
    marginBottom: PropTypes.number,
};



// WEBPACK FOOTER //
// ./src/components/Divider.jsx